<template>
  <div
    class="default-layout"
    :class="{
      'default-layout--bottom-offset': isTimerVisible,
    }"
  >
    <ReservedTimer v-if="isTimerVisible" />

    <DefaultHeader class="default-layout__header" />

    <main class="default-layout__container">
      <router-view v-slot="{ Component }">
        <!-- <transition name="fade-view" appear mode="out-in"> -->
        <component :is="Component" :key="rerenderKey" />
        <!-- </transition> -->
      </router-view>
    </main>

    <DefaultFooter />

    <Messenger v-if="isShowMessenger" />

    <BaseModal />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapState, mapGetters } from 'vuex';
import { store } from '@/store';

import ReservedTimer from '@/layouts/ReservedTimer.vue';
// import Messenger from '@/components/Messenger.vue';
import BaseModal from '@/modals/BaseModal.vue';
import DefaultFooter from './DefaultFooter.vue';
import DefaultHeader from './default-header/DefaultHeader.vue';

import { getUserProfile } from '@/api/user';

const Messenger = defineAsyncComponent(() =>
  import('@/components/Messenger.vue')
);

export default {
  name: 'DefaultLayout',

  components: {
    DefaultHeader,
    DefaultFooter,
    Messenger,
    BaseModal,
    ReservedTimer,
  },

  async beforeRouteEnter(_to, from, next) {
    const isFirstLoad = !from.name;
    const isUserEmpty = store.getters['auth/userEmpty'];

    if (isFirstLoad) {
      const logSessionEvent = (vm, status) => {
        const isAnalyticCookie = vm.$cookies.get('AnalyticSessionCookies');

        if (!isAnalyticCookie) {
          vm.$amplitude.logEvent('Session_start', {
            user_status: status,
          });

          vm.$cookies.set('AnalyticSessionCookies', true, 60 * 30); // 30 min
        }
      };

      if (isUserEmpty) {
        try {
          const user = await getUserProfile();

          store.commit('auth/SET_USER', user);

          next((vm) => {
            vm.$amplitude.setUserId(user.uuid);
            logSessionEvent(vm, 'authorized');
          });
        } catch (error) {
          store.commit('auth/SET_TOKEN', '');
          store.commit('auth/SET_USER', {});

          next((vm) => logSessionEvent(vm, 'not_authorized'));
        }
      } else {
        next((vm) => logSessionEvent(vm, 'not_authorized'));
      }
    } else {
      next();
    }
  },

  computed: {
    ...mapState('pricing', ['isTimerVisible']),
    ...mapGetters('auth', ['userEmpty']),
    rerenderKey() {
      return this.$route.path + String(this.userEmpty);
    },
    isShowMessenger() {
      return (
        !this.userEmpty &&
        ['MyPlants', 'Home', 'ExplorePlants', 'Calendar'].includes(
          this.$route.name
        )
      );
    },
  },

  watch: {
    userEmpty: {
      async handler(isEmpty) {
        if (isEmpty) return;

        this.$store.dispatch('my-plants/setMyPlantsFetching', true);

        try {
          await this.$store.dispatch('my-plants/getCareTypesList');
          await this.$store.dispatch('my-plants/getMyPlants');
        } catch (error) {
          this.$store.dispatch('my-plants/setMyPlantsFetchError', true);
        }

        this.$store.dispatch('my-plants/setMyPlantsFetching', false);
      },
      immediate: true,
    },
  },

  async created() {
    const storageToken = localStorage.getItem('token');

    if (storageToken) {
      this.$store.commit('auth/SET_TOKEN', storageToken);
    }

    if (localStorage.getItem('timerInitialTime')) {
      this.$store.dispatch('pricing/setTimerVisibility', true);
    }
  },
};
</script>

<style lang="scss" scoped>
.default-layout {
  $this: 'default-layout';
  display: flex;
  flex-direction: column;
  min-height: 100%;

  &--bottom-offset {
    @include media('md') {
      padding-bottom: 104px;
    }
  }

  &__container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
}

.fade-view-enter-active {
  transition: opacity 0.3s ease;
}

.fade-view-enter-from {
  opacity: 0;
}
</style>
